module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.3-131.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.3.md
// module id = 549
// module chunks = 247